export default {
  namespaced: true,
  state: {
    left: false,
    right: false
  },
  getters: {
    left: state => state.left,
    right: state => state.right
  },
  mutations: {
    collapseByLeft(state, bool) {
      state.left = bool
    },
    collapseByRight(state, bool) {
      state.right = bool
    }
  }
}
